import { createVariants } from 'shared-ui/lib'

const segmentGroupClasses = createVariants({
  base: 'flex h-8 shrink-0 items-center gap-0.5 rounded-lg bg-gray-100 p-0.5',
  variants: {
    disabled: { true: 'opacity-50' }
  }
})

const segmentClasses = createVariants({
  base: 'pan-detail h-7 whitespace-nowrap rounded-md px-2 disabled:cursor-not-allowed',
  variants: {
    selected: {
      true: 'bg-white text-gray-900 shadow-sm',
      false: 'text-gray-600 hover:text-gray-900'
    }
  }
})

type BinaryOption<T> = {
  value: T
  label: string
}

/**
 * A choice between two options with both labels always visible.
 */
export const BinaryChoice = <T extends string>({
  label,
  options,
  value,
  disabled,
  onChange
}: {
  label: string
  options: readonly [BinaryOption<T>, BinaryOption<T>]
  value: T
  disabled: boolean
  onChange: (value: T) => void
}) => (
  <div role="radiogroup" aria-label={label} className={segmentGroupClasses({ disabled })}>
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        role="radio"
        aria-checked={option.value === value}
        disabled={disabled}
        className={segmentClasses({ selected: option.value === value })}
        onClick={() => option.value !== value && onChange(option.value)}
      >
        {option.label}
      </button>
    ))}
  </div>
)
